module.exports = __webpack_public_path__ + "img/point_tab_exchange_records.ea1e36bb.svg";